import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import tagIcon from '../../common/helpers/tagIcon';
export default class TagLinkButton extends LinkButton {
  view(vnode) {
    const tag = this.attrs.model;
    const description = tag && tag.description();
    const className = classList('TagLinkButton hasIcon', {
      child: tag?.isChild()
    }, this.attrs.className);
    return m(Link, {
      className: className,
      href: this.attrs.route,
      style: tag ? {
        '--color': tag.color()
      } : undefined,
      title: description || undefined
    }, listItems(this.linkItems(tag).toArray()));
  }

  /**
   * Build the contents of the tag link. Exposed as an ItemList so extensions can
   * add to it (e.g. a realtime typing dot) without overriding the whole view.
   */
  linkItems(tag) {
    const items = new ItemList();
    items.add('icon', tagIcon(tag, {
      className: 'Button-icon'
    }), 100);
    items.add('label', m("span", {
      className: "Button-label"
    }, tag ? tag.name() : app.translator.trans('nightash-labels.forum.index.untagged_link')), 90);
    return items;
  }
  static initAttrs(attrs) {
    super.initAttrs(attrs);
    const tag = attrs.model;
    attrs.params = attrs.params || {};
    attrs.params.tags = tag ? tag.slug() : 'untagged';
    attrs.route = app.route('tag', attrs.params);
  }
}
flarum.reg.add('nightash-labels', 'forum/components/TagLinkButton', TagLinkButton);